module.exports = "/assets/data/0df349feaf26b599a69712185050ca2c-CB25.data.json";